<template>
  <el-form class="time-control" :model="control" label-width="70px">
    <el-form-item prop="name">
      <template slot="label">
        <span class="require-flag">*</span>
        名称
      </template>
      <el-input v-model="control.name"></el-input>
    </el-form-item>
    <el-form-item prop="timeType">
      <template slot="label">类型</template>
      <el-select v-model="control.timeType" @change="clearTimeScope">
        <el-option
          v-for="type in timeTypeList"
          :key="type.value"
          :label="type.label"
          :value="type.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item prop="defaultVal">
      <template slot="label">
        默认值
      </template>
      <default-val-input
        ref="defaultVal"
        :key="control._cid"
        :cur-control="control"
        :sheet="sheet"
        :available-sheet-map="availableSheetMap"
        :value="control.defaultVal"
      ></default-val-input>
    </el-form-item>
    <el-form-item prop="hint">
      <template slot="label">
        提示
      </template>
      <el-input v-model="control.hint"></el-input>
    </el-form-item>
    <el-form-item prop="description">
      <template slot="label">
        描述
      </template>
      <el-input v-model="control.description"></el-input>
    </el-form-item>
    <el-form-item prop="timeScope">
      <template slot="label">
        范围
      </template>
      <time-scope v-model="control.timeScope" :control="control"></time-scope>
    </el-form-item>
    <el-form-item prop="required">
      <template slot="label">
        必填
      </template>
      <el-checkbox v-model="control.required" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="display">
      <template slot="label">
        显示
      </template>
      <el-checkbox v-model="control.display" :disabled="control.main"></el-checkbox>
    </el-form-item>
    <el-form-item prop="disabled">
      <template slot="label">
        不可编辑
      </template>
      <el-checkbox v-model="control.disabled"></el-checkbox>
    </el-form-item>
    <el-form-item prop="main">
      <template slot="label">
        标题
      </template>
      <el-checkbox v-model="control.main" @change="checkChange($event)"></el-checkbox>
    </el-form-item>
  </el-form>
</template>

<script>
import { timeTypeList } from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/static"
import DefaultValInput from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/default-val-input"
import TimeScope from "@/views/Backend/AdminEdit/Sheet/Field/detail-setting-content/control-setting/TimeScope"

export default {
  name: "time-control",
  components: { TimeScope, DefaultValInput },
  props: {
    control: Object,
    sheet: Object,
    availableSheetMap: Object
  },
  data() {
    return {
      timeTypeList
    }
  },
  methods: {
    checkChange(value) {
      this.$emit("checkboxChange", "main", value)
    },
    clearTimeScope(val) {
      this.control.timeScope.weekLimit = null
      this.control.timeScope.timeRange = null
      this.control.timeScope.dateRange = null
    }
  }
}
</script>

<style lang="scss" scoped>
.time-control {
}
</style>
